import React from 'react'
import { Row, ControlLabel } from 'rsuite'
import { numberThousandSeparator } from '../../utils/formatterUtil'

export default function ShowLimitLength({ textLength, maxLength }) {
  const colorLimit = (onKey, max) => {
    let color = ''
    if (onKey > max) {
      color = '#d62915'
    } else {
      color = '#2da988'
    }

    return color
  }

  return (
    <>
      {maxLength && (
        <Row style={{ textAlign: 'right', marginRight: '2px' }}>
          <ControlLabel className={textLength > maxLength ? 'limit-length-over' : 'limit-length'}>
            {numberThousandSeparator(textLength)} / {numberThousandSeparator(maxLength)}
          </ControlLabel>
        </Row>
      )}
    </>
  )
}
